import {ReactElement} from 'react'
import {ToastContainer, Flip} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function NotificationWrapper(): ReactElement {
  return (
    <ToastContainer
      position={'top-center'}
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      rtl
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={2}
      transition={Flip}
    />
  )
}

export default NotificationWrapper